import { render } from "./MinhaConta.vue?vue&type=template&id=6f3495d1&scoped=true"
import script from "./MinhaConta.vue?vue&type=script&lang=js"
export * from "./MinhaConta.vue?vue&type=script&lang=js"

import "./MinhaConta.vue?vue&type=style&index=0&id=6f3495d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3495d1"]])

export default __exports__